import { monolithHttpClient } from 'src/editor/api/http-clients/monolith-http-client'

export const getAgreement = (pageId: number | string) => {
  return monolithHttpClient.get<string>(`/pages/${pageId}/user-agreement`)
}
